import React, { useEffect, useState } from 'react';
import { useParams, useOutletContext, useLocation } from 'react-router-dom';
import axios from 'axios';
import './HistoryPage.css';
import PropertyInfo from './PropertyInfo';

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_PROXY_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});
const HistoryPage = () => {
const { customerId, taxid, taxyear, yearshistory } = useParams();
const { state } = useLocation();
const payoffDate = state?.payoffDate ?? null;
const [dataHistory, setDataHistory] = useState([]);
const [isLoading, setIsLoading] = useState(true);
const [error, setError] = useState(null);
const { dataProperty } = useOutletContext();
const proxyUrl = process.env.REACT_APP_PROXY_URL;

  useEffect(() => {
    setIsLoading(true);
    const fetchData = async () => {
      try {
        //const responseHistory = await apiClient.get(
        //`/api/history/${customerId}/${taxid}/${taxyear}/${yearshistory}`
        const payload = {
            taxId: taxid,
            taxYear: taxyear,
            customerId: customerId,        // this matches your backend current usage; adjust if dataPath differs
            yearsHistory: yearshistory,
            payoffDate: payoffDate || null
          };
        const responseHistory = await apiClient.post(`/api/history/detail`, payload);
        const result = responseHistory?.data?.result ?? responseHistory?.data ?? [];
        console.log("History result sample:", result?.[0]?.transactions?.[0]);
        setDataHistory(Array.isArray(result) ? result : []);

      } catch (error) {
        setError(error);
      }
      finally 
       {
      setIsLoading(false);
      }
    };
    fetchData();
  }, [customerId, taxid, taxyear, yearshistory, payoffDate]);

  const formatCurrency = (amountStr) => {
    const amount = parseFloat(amountStr);
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(amount || 0);
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '';

    const date = new Date(dateStr);

    if (isNaN(date.getTime())) {
      return '';
    }

    const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
    const day = date.getUTCDate().toString().padStart(2, '0');
    const year = date.getUTCFullYear();

    return `${month}/${day}/${year}`;
  };

  const formatYear = (yearStr) => {
    if (!yearStr) return '';
    const year = yearStr.toString();
    const lastTwoDigits = year.slice(-2);
    return lastTwoDigits.padStart(2, '0');
  };

  const parseYear = (yearStr) => {
    if (!yearStr) return 0;
    let year = parseInt(yearStr, 10);

    const currentYearTwoDigit = parseInt(
      new Date().getFullYear().toString().slice(-2),
      10
    );

    if (year <= currentYearTwoDigit) {
      year += 2000;
    } else {
      year += 1900;
    }

    return year;
  };

  // Modified groupTransactions function
  const groupTransactions = (dataHistory) => {
    const groupedByYear = {};
  
    dataHistory.forEach((historyItem) => {
      const transactions = historyItem.transactions || [];
      transactions.forEach((transaction) => {
        const year = transaction.propertyTaxYear;
  
        if (!groupedByYear[year]) {
          groupedByYear[year] = {
            year: year,
            totalAmount: 0,
            groups: {},
          };
        }
  
        // Group by propertyTaxDate and propertyTaxPaymentStatus
        const groupKey = `${transaction.propertyTaxPaymentStatus}-${transaction.propertyTaxDate}`;
  
        if (!groupedByYear[year].groups[groupKey]) {
          groupedByYear[year].groups[groupKey] = {
            paymentStatus: transaction.propertyTaxPaymentStatus,
            taxDate: transaction.propertyTaxDate,
            postDate: transaction.propertyTaxPostDate,
            receiptDate: transaction.propertyTaxReceiptDate,
            intDate: transaction.propertyTaxIntDate || null,
            groupTotalAmount: 0,
            penaltyAmount: 0,
            interestAmount: 0,
          };
        }
  
        // Sum up amounts for the group
        const taxAmount = parseFloat(transaction.propertyTaxAmount) || 0;
        const penaltyAmount = parseFloat(transaction.propertyTaxPenalty) || 0;
        const interestAmount = parseFloat(transaction.propertyTaxInterest) || 0;
        const transactionTotal = taxAmount + penaltyAmount + interestAmount;
  
        groupedByYear[year].groups[groupKey].groupTotalAmount += taxAmount;
        groupedByYear[year].groups[groupKey].penaltyAmount += penaltyAmount;
        groupedByYear[year].groups[groupKey].interestAmount += interestAmount;
  
        // Sum up total amount for the year
        groupedByYear[year].totalAmount += transactionTotal;
      });
    });
  
    // Modify groups: handle ASSIGNMENT and PAID statuses
    Object.keys(groupedByYear).forEach((year) => {
      const groups = groupedByYear[year].groups;
      const keysToRemove = [];
  
      Object.keys(groups).forEach((key) => {
        const group = groups[key];
        if (group.paymentStatus === "ASSIGNMENT") {
          const normalizedTaxDate = group.taxDate.split(" ")[0]; // Remove the time part
          const matchingPaidKey = Object.keys(groups).find(
            (k) =>
              groups[k].paymentStatus === "PAID" &&
              groups[k].taxDate === normalizedTaxDate
          );
  
          if (matchingPaidKey) {
            // Update the matching PAID item to ASSIGNMENT
            groups[matchingPaidKey].paymentStatus = "ASSIGNMENT";
            // Mark the current ASSIGNMENT item for removal
            keysToRemove.push(key);
          }
        }
      });
  
      // Remove ASSIGNMENT keys that are no longer needed
      keysToRemove.forEach((key) => {
        delete groups[key];
      });
    });
  
    // Convert groups to array and sort them by taxDate descending
    Object.values(groupedByYear).forEach((yearGroup) => {
      yearGroup.groups = Object.values(yearGroup.groups).sort((a, b) => {
        const dateA = new Date(a.taxDate);
        const dateB = new Date(b.taxDate);
        return dateB - dateA;
      });
    });
  
    return Object.values(groupedByYear);
  };
  
if (error) return <div>Error: {error.message}</div>;
if (isLoading) return <p>Loading...</p>;

if (dataHistory.length === 0) {
  return (
    <div className="history-page">
      <div className="content">
        <PropertyInfo
          dataProperty={dataProperty}
          dataTax={[]}
          proxyUrl={proxyUrl}
        />
      </div>

      <h1>Payment History</h1>
      <div className="history-items">
        <div className="no-records">No records found</div>
      </div>
    </div>
  );
}

const groupedData = groupTransactions(dataHistory);

  return (
    <div className="history-page">
      <div className="content">
        <PropertyInfo dataProperty={dataProperty} dataTax={[]} proxyUrl={proxyUrl} />
      </div>

      <h1>Payment History</h1>
      <div id="detailItems">
        <div id="detailItemHeader">
          <ul className="listDetail">
            <li className="listDetail">
              <span className="taxstatus"></span>
              <span className="taxyear">YR</span>
              <span className="int_date">Int. Date</span>
              <span className="tax_date">Tax Date</span>
              <span className="tax_amt">Tax Amt</span>
              <span className="penalty_am">Penalty</span>
              <span className="interest_a">Interest</span>
              <span className="total_am">Total Amt</span>
              <span className="total_year">Total Year</span>
            </li>
          </ul>
        </div>

        <div className="history-items">
          {groupedData
            .sort((a, b) => parseYear(b.year) - parseYear(a.year))
            .flatMap((yearGroup) => {
              const { year, groups, totalAmount } = yearGroup;
              const displayTotalYear = formatCurrency(totalAmount.toFixed(2));

              return groups.map((group, groupIndex) => {
                const {
                  paymentStatus,
                  taxDate,
                  postDate,
                  receiptDate,
                  intDate,
                  groupTotalAmount,
                  penaltyAmount,
                  interestAmount,
                } = group;

                const rowTotalAmount = groupTotalAmount + penaltyAmount + interestAmount;
                const displayTotalAmount = formatCurrency(rowTotalAmount.toFixed(2));
                // WEST-709: show the combined year total once per year (first row of the
                // year's group, matching how classic bolds it on one of the two installment
                // rows), rather than making the user add the two rows themselves.
                const isFirstRowOfYear = groupIndex === 0;

                return (
                  <ul
                    key={`${year}-${paymentStatus}-${taxDate}`}
                    className="listDetail"
                  >
                    <li className="listDetail">
                      <span className="taxstatus">{paymentStatus}</span>
                      <span className="taxyear">{formatYear(year)}</span>
                      <span className="int_date">{(paymentStatus === 'DUE' || paymentStatus === 'ASSIGNMENT') ? formatDate(intDate) : paymentStatus === 'PAID' ? formatDate(receiptDate ||  postDate) : formatDate(postDate)}</span>
                      <span className="tax_date">{formatDate(taxDate)}</span>
                      <span className="tax_amt">
                        {formatCurrency(groupTotalAmount.toFixed(2))}
                      </span>
                      <span className="penalty_am">
                        {formatCurrency(penaltyAmount.toFixed(2))}
                      </span>
                      <span className="interest_a">
                        {formatCurrency(interestAmount.toFixed(2))}
                      </span>
                      <span className="total_am">{displayTotalAmount}</span>
                      <span className="total_year">
                        {isFirstRowOfYear ? (
                          <strong>{displayTotalYear}</strong>
                        ) : (
                          ''
                        )}
                      </span>
                    </li>
                  </ul>
                );
              });
            })}
        </div>
      </div>
    </div>
  );
};

export default HistoryPage;
